import React from "react";

import "./antCustom.less";

import { Provider } from "react-redux";

import { createRoot } from "react-dom/client";

import Authenticator from "./Components/Authenticator/Authenticator";
import { AuthProvider } from "./contexts/auth-context";
import store from "./Store";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <AuthProvider>
    <Provider store={store}>
      <Authenticator />
    </Provider>
  </AuthProvider>
);
